
import * as React from 'react';
import { withOnlyCurrentItem } from '../../decorators/selectors';
import { WithItemCache, IItemCacheStateProps } from '../../withItemCache/WithItemCache';
import { IWizardActionStateProps, BackgroundAction } from '../../wizardAction/WizardAction';
import SocialBarPanel from '../../fileHoverCard/hoverCardStats/SocialBarPanel';

/**
 * @public
 */
export interface IShowSocialBarActionProps {
  itemKey: string;
}

/**
 * Action which sets the given item as the current item in the current items scope context.
 * @public
 */
export class ShowSocialBarAction extends React.PureComponent<IShowSocialBarActionProps> {
  public render(): JSX.Element {
    const {
      itemKey
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {
          return (
            <BackgroundAction>
              { (wizardProps: IWizardActionStateProps) => {
                return (
                  <SocialBarPanel
                    { ...wizardProps }
                    itemKey={ itemKey }
                  />
                );
              } }
            </BackgroundAction>
          );
        } }
      </WithItemCache>
    );
  }
}

export const CurrentShowSocialBarAction = withOnlyCurrentItem()(ShowSocialBarAction);